import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// La ligne ci-dessous est désactivée pour la mise en production.
// Elle ne doit être activée que pour le débogage local.
// window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialiser l'application Firebase
const app = initializeApp(firebaseConfig);

// Initialiser App Check avec reCAPTCHA v3
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(process.env.REACT_APP_RECAPTCHA_SITE_KEY),
  isTokenAutoRefreshEnabled: true
});

// Initialiser l'authentification
const auth = getAuth(app);

// Initialiser Firestore avec configuration pour éviter le cache
const db = getFirestore(app);

// Attendre que l'initialisation soit terminée
const initializeFirebase = async () => {
  try {
    await auth.authStateReady();
    console.log("Firebase initialisé avec succès");
  } catch (error) {
    console.error("Erreur lors de l'initialisation de Firebase:", error);
  }
};

// Initialiser Firebase
initializeFirebase();

export { app, auth, db };